import { useInView } from './hooks';
import { MOTION_TIMING } from './timing';

// Rises into place the first time it scrolls into view. `delay` staggers siblings (ms).
export default function Reveal({ as: Tag = 'div', className = '', delay = 0, children, ...rest }) {
  const [ref, inView] = useInView();
  return (
    <Tag
      ref={ref}
      className={`reveal ${inView ? 'is-in' : ''} ${className}`}
      style={delay ? { transitionDelay: `${Math.round(delay * MOTION_TIMING.revealDelayScale)}ms` } : undefined}
      {...rest}
    >
      {children}
    </Tag>
  );
}
